/**
 * Converts a string to camelCase format.
 *
 * @param {string} str - The input string to convert
 * @returns {string} The converted camelCase string
 *
 * @example
 * toCamelCase('hello-world');     // returns 'helloWorld'
 * toCamelCase('foo_bar');         // returns 'fooBar'
 * toCamelCase('Hello World');     // returns 'helloWorld'
 * toCamelCase('--foo-bar--');     // returns 'fooBar'
 *
 * @description
 * This function:
 * - Removes leading and trailing spaces, hyphens, and underscores
 * - Converts the string to lowercase
 * - Splits the string by spaces, hyphens, or underscores
 * - Capitalizes the first letter of each word except the first one
 * - Joins all words together
 */
export default function toCamelCase(str: string) {
	return str
		.replace(/^[\s-_]+|[\s-_]+$/g, "") // Remove leading and trailing delimiters
		.toLowerCase()
		.split(/[\s-_]+/) // Split the string by space, underscore, or hyphen
		.map((word, index) => {
			// If it's the first word, return it as is. Otherwise, capitalize the first letter.
			return index === 0 ? word : word.charAt(0).toUpperCase() + word.slice(1);
		})
		.join(""); // Join all the words together
}
